import { Link } from 'react-router';
import { Icon } from './Icon';

export function SurahCard({ surah }) {
  return (
    <Link className="surah-card" to={surah.path}>
      <div className="surah-number" aria-hidden="true"><span>{surah.number}</span></div>
      <div className="surah-card-main">
        <span className="surah-arabic" lang="ar" dir="rtl">{surah.arabicName}</span>
        <h3>{surah.latinName}</h3>
        <p>{surah.meaning} <span>· {surah.verseCount} verzen</span></p>
      </div>
      <div className="surah-card-meta">
        <Icon name="arrow" className="card-arrow icon-up-right" />
      </div>
    </Link>
  );
}
